import Vue from 'vue'
export default {
  state: {
  },
  mutations: {
  },
  actions:{
    //刷新异常列表
    reloadAbnormalTable(){
      Vue.prototype.$bus.$emit('reloadAbnormalTable')
    }
  },
  getters:{
  },
}